import { MouseEventHandler, PropsWithChildren } from 'react';
import { FC } from 'react';

export type FlatShadowBoxColor =
  | 'light-1'
  | 'light-2'
  | 'light-3'
  | 'light-4'
  | 'seasalt'
  | 'platinum-1'
  | 'white'
  | 'primary'
  | 'lighter-blue'
  | 'lighter-orange'
  | 'lighter-violet'
  | 'mystic'
  | 'cloudy'
  | 'lavender-web'
  | 'default'; // default color (athens-gray)

type ShadowBoxProps = PropsWithChildren<{
  className?: string;
  color?: FlatShadowBoxColor;
  flat?: boolean;
  whiteOnHover?: boolean;
  flatOnHover?: boolean;
  shadowOnHover?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
  onMouseEnter?: MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: MouseEventHandler<HTMLDivElement>;
  dataCy?: string;
}>;

const ShadowBox: FC<ShadowBoxProps> = ({
  className,
  children,
  flat = false,
  color = '',
  whiteOnHover = false,
  flatOnHover = false,
  shadowOnHover = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
  ...rest
}) => {
  return (
    <div
      className={`shadow-box-wrap ${className ? className : ''} ${flat ? 'flat-box' : ''} ${
        whiteOnHover ? 'white-on-hover' : ''
      } ${flatOnHover ? 'flat-on-hover' : ''} ${shadowOnHover ? 'shadow-on-hover' : ''} ${color}`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...rest}
    >
      {children}
    </div>
  );
};

export default ShadowBox;
